var React = require('react');

function Lamp (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"lamp"),React.createElement("path",{"d":"M179.8218,89.9184a89.9184,89.9184,0,0,0-179.8368,0c0,1.3483.0353,2.6881.094,4.0219A89.6283,89.6283,0,0,0,24.132,159.236a40.3292,40.3292,0,0,1,11.0385,27.4647v21.1376a54.733,54.733,0,0,0,54.7329,54.7329h0a54.7329,54.7329,0,0,0,54.7328-54.7329v-20.946a40.7746,40.7746,0,0,1,11.1126-27.7357A89.5863,89.5863,0,0,0,179.8218,97.93c0-1.325-.0387-2.6407-.0954-3.9517C179.7862,92.6319,179.8218,91.2794,179.8218,89.9184Z","style":{"fill":"#f5aa28"},"key":1}),React.createElement("rect",{"x":"74.917","y":"112.8804","width":"29.9728","height":"104.9048","rx":"14.9864","style":{"fill":"#f0625d"},"key":2})]);
}

Lamp.defaultProps = {"width":"179.8218","height":"262.5712","viewBox":"0 0 179.8218 262.5712"};

module.exports = Lamp;

Lamp.default = Lamp;
